// Servis koji posta evente za Iterable
import { reportError } from '@PROJECT_ROOT/assets/responsive-frontend/js/services/reportService';
import { apiPostIterableData } from '@PROJECT_ROOT/assets/responsive-frontend/js/services/apiService';
import userData from '@PROJECT_ROOT/assets/responsive-frontend/js/services/userData';

function postData(path, data) {
    const user = userData.getDecodedUserDataFromLocalStorage();
    const isLoggedIn = user !== '0';
    let updatedPostData = {
        ...data,
    };

    if ((path === 'search-event' || path === 'register-user') && isLoggedIn) {
        updatedPostData = {
            ...updatedPostData,
            email: user.username,
        };
    }

    return apiPostIterableData(path, updatedPostData)
        .then((res) => {
            if (res.status === 200) {
                return res.data;
            }
            reportError(res);
            return null;
        })
        .catch((err) => {
            reportError(err);
        });
}

export default {
    postData,
};
